module.exports = __webpack_public_path__ + "img/help.cbf60c2c.svg";